var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "12", md: "4" } },
            [
              _c("pga-currency-field", {
                attrs: { label: "Total Taxable Amount", readonly: "" },
                model: {
                  value: _vm.totalTaxableAmount,
                  callback: function ($$v) {
                    _vm.totalTaxableAmount = $$v
                  },
                  expression: "totalTaxableAmount",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }